import { isOutcomeUnknown, type ApiErrorBody } from '@icebreaker/shared';

/**
 * SONUCU BİLİNMEYEN HATA (T4 QA P2-1): kuralın TEK kaynağı artık ortak pakettir
 * (`@icebreaker/shared` · `errors/write-outcome`); web de aynısını okur.
 */
export { isOutcomeUnknown };

/**
 * Yazma diyaloğunun hata sonucu: `unknown` (sonuç doğrulanamadı), `rejected`
 * (alan hatası olmayan kesin ret) ya da `none`. Alan hataları alanın altında
 * yazıldığı için burada `none` sayılır.
 */
export function failureKind(
  phase: string,
  error: ApiErrorBody | null,
): 'none' | 'unknown' | 'rejected' {
  if (phase !== 'failed' || !error) return 'none';
  if (isOutcomeUnknown(error)) return 'unknown';
  return (error.fieldErrors?.length ?? 0) > 0 ? 'none' : 'rejected';
}

/**
 * YAZMADAN SONRA YENİDEN ÇEKME (tech-lead T4 QA turu): sonuç bilinmiyorsa
 * ya da sunucu 409 (çakışma) döndüyse ekranın varsaydığı hâl gerçekle
 * ayrışmıştır ve ilgili veri yeniden çekilir. 409'un tipik yolu: ilk deneme
 * sunucuda işlendi ama yanıt koptu, "Tekrar dene" sunucu anahtarı olmayan bir
 * uçta (sözleşme sonlandırma, sahip daveti) ikinci kez gitti ve "zaten
 * sonlandırılmış / bekleyen davet var" cevabını aldı. Kayıt çift yazılmaz,
 * ama arkadaki kart da eski hâlde kalmamalı. Diğer 4xx kesin rettir, çekilmez.
 */
export function refetchesAfterFailure(error: ApiErrorBody | null | undefined): boolean {
  if (!error) return false;
  return isOutcomeUnknown(error) || error.statusCode === 409;
}
